import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <main className="max-w-xl mx-auto px-6 mt-20 min-h-[50vh] text-center flex flex-col items-center">
    <XCircle size={52} className="text-[#0e2a1e]/40" />
    <h1 className="font-serif-brand text-3xl font-semibold text-[#0e2a1e] mt-6">Payment cancelled</h1>
    <p className="text-[#0e2a1e]/70 mt-3">No charge was made. Your bag is still saved if you'd like to try again.</p>
    <Link to="/cart" className="mt-8 bg-[#a4d61e] text-[#0e2a1e] font-semibold px-8 py-3.5 rounded-full hover:bg-[#b6e63a] transition-colors">
      Return to cart
    </Link>
  </main>
);

export default PaymentCancel;
